import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <div className='footer'>
      <p>© 2024 Edusity. All rights reserved.</p>
      <ul>
        <li>Terms of Serviced</li>
        <li>Privacy Policy</li>
      </ul>
    </div>
  );
}

export default Footer;
